module.exports = __webpack_public_path__ + "static/bedroom_top_right_night_mobile-5e7404b34202ae01592215fa2ead482a.jpg";